import { useCallback } from "react";

import { Checkbox, DateTimePicker } from "@repo/ui";

import type { IMapFilter } from "./filterContext";
import { AddressDropdown } from "../../../components/addressDropdown";
import { useMapSettings } from "../hooks";
import { useMapFilters } from "./filterContext";

export function GeographicViewFilters() {
	const { filters, setFilters } = useMapFilters();
	const mapSettingsQuery = useMapSettings();

	const filterChanged = useCallback(
		(value: any, name: string & keyof IMapFilter) => setFilters({ ...filters, [name]: value }),
		[filters, setFilters],
	);

	return (
		<>
			<AddressDropdown
				label="Point of Interest"
				placeholder="Search Addresses..."
				id="poi"
				value={filters.poi}
				changeHandler={filterChanged}
			/>
			<Checkbox
				id="activeOnly"
				label={"Active Only"}
				value={filters.activeOnly}
				changeHandler={filterChanged}
				inline
				hidden={!mapSettingsQuery.data?.canShowRetailLocations}
			/>
			<DateTimePicker
				id="startDateTime"
				label="Start Date"
				value={filters.startDateTime}
				changeHandler={filterChanged}
			/>
			<DateTimePicker
				id="endDateTime"
				label="End Date"
				value={filters.endDateTime}
				changeHandler={filterChanged}
			/>
		</>
	);
}
